var map = {
	"./bullet-points.png": "04c3",
	"./color-icon.png": "bbc7",
	"./delete-button.png": "f67a",
	"./dendro.png": "934f",
	"./download.png": "f6f5",
	"./index-spline-icon.png": "ebed",
	"./info-icon.png": "f49b",
	"./legend-1.png": "ffe5",
	"./legend-2.png": "3b8d",
	"./legend-3.png": "e206",
	"./legend-button.png": "ef81",
	"./redo-button.png": "b98a",
	"./sort-button.png": "60eb",
	"./spaghetti-plot.png": "55b1",
	"./spaghetti.png": "5e29",
	"./swap-color-a-icon.png": "d4a7",
	"./swap-color-b-icon.png": "015d",
	"./toggle-icon.png": "5a40",
	"./undo-button.png": "fe5f",
	"./upload.png": "cf55",
	"./width-spline-icon.png": "284a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";